import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiSend, FiTrendingUp, FiClock } from 'react-icons/fi';
import Navbar from '../../components/marketing/Navbar';
import Footer from '../../components/marketing/Footer';

const FeaturesPage: React.FC = () => {
  useEffect(() => {
    document.title = 'Features — Sedra Invoices';
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main id="main" className="flex-1">
        <section className="mx-auto max-w-7xl px-6 lg:px-8 pt-16 lg:pt-24 pb-16">
          <header className="max-w-3xl">
            <h1 className="display-hero text-4xl sm:text-5xl font-extrabold leading-tight tracking-tight text-gray-900">
              Built for small service businesses.
            </h1>
            <p className="mt-4 text-lg text-gray-600">Tools that help you get invoices out the door, get paid, and stay organized.</p>
          </header>

          <ul className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
            {[{icon: FiSend, title: 'Send invoices faster', body: 'Create and send branded invoices in minutes.'},
              {icon: FiTrendingUp, title: 'Track payments automatically', body: 'See who paid and what is overdue at a glance.'},
              {icon: FiClock, title: 'Stay organized', body: 'Keep customers, rates, and documents in one place.'}
            ].map(({icon: Icon, title, body}) => (
              <li key={title} className="rounded-2xl border border-gray-200 bg-white p-6 elev-1">
                <div className="flex items-center gap-3">
                  <Icon aria-hidden className="h-6 w-6 text-sedra" />
                  <h3 className="text-base font-semibold text-gray-900">{title}</h3>
                </div>
                <p className="mt-3 text-sm text-gray-600">{body}</p>
              </li>
            ))}
          </ul>

          <div className="mt-12 flex flex-wrap gap-4">
            <Link to="/register" className="inline-flex items-center justify-center rounded-xl px-6 py-3 text-base font-semibold text-white bg-sedra hover:bg-sedra-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-sedra transition-colors">Get started</Link>
            <Link to="/login" className="inline-flex items-center justify-center rounded-xl px-6 py-3 text-base font-semibold border border-sedra text-sedra hover:bg-sedra/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-sedra transition-colors">Sign in</Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default FeaturesPage; 